import { ConsoleFacade } from '@/shared/helpers';

export class DelayedExecution {

    private executionId = 1;

    constructor(private delayMs: number) { }

    public execute(func: () => void): void {

        this.executionId++;

        const currentExecutionId = this.executionId;

        setTimeout(() => {

            if (this.executionId !== currentExecutionId) {

                ConsoleFacade.log(`DelayedExecution: Ignore due to wrong execution id`);
                return;
            }

            func();

        }, this.delayMs);
    }
}